import { render } from "./LocationView.vue?vue&type=template&id=0c8c87fb&scoped=true"
import script from "./LocationView.vue?vue&type=script&lang=js"
export * from "./LocationView.vue?vue&type=script&lang=js"

import "./LocationView.vue?vue&type=style&index=0&id=0c8c87fb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8c87fb"]])

export default __exports__